import { GET_COMPANIES_FOR_SELECT } from 'src/api/graphql/queries/companiesForSelect.gql';
import { fetchList } from './fetchLists';

const DEFAULT_LIMIT = 50;

const buildSearchFilters = (search) => {
	const trimmed = search?.trim();

	if (!trimmed) return undefined;

	if (/^\d+$/.test(trimmed)) {
		return { gorkoId: { eq: [Number(trimmed)] } };
	}

	return { name: { contains: [trimmed] } };
};

export const getCompaniesForAreaSelect = async ({
	search = '',
	page = 1,
	limit = DEFAULT_LIMIT,
	ids,
} = {}) => {
	const filters = ids?.length
		? { id: { eq: ids.map(String) } }
		: buildSearchFilters(search);

	const { items } = await fetchList({
		query: GET_COMPANIES_FOR_SELECT,
		variables: {
			page,
			limit: ids?.length ? Math.max(ids.length, limit) : limit,
			...(filters ? { filters } : {}),
		},
	});

	return items;
};
